import VideoTitle from "./VideoTitle";
import VideoBackground from "./VideoBackground";
import { useSelector } from "react-redux";

const MainContainer = () => {
  //getting now playing movies froms store
  const movies = useSelector((store) => store.movies?.nowPlayingMovies);

  //Early return, writing like this industry std. Read as if movies is not present.
  if (!movies) return;

  const mainMovie = movies[2];
  // console.log(mainMovie);

  const { title, overview, genre_ids, id } = mainMovie;

  return (
    <div>
      <VideoTitle
        title={title}
        overview={overview}
        genre_ids={genre_ids}
        id={id}
      />
      <VideoBackground movieId={id} />
    </div>
  );
};

export default MainContainer;
